import { Minus } from '@hungryroot/icons';
import { IconButton } from '@hungryroot/ramen';
import styles from './MinusButton.module.css';

interface MinusButtonProps {
  onClick: () => void;
  className?: string;
}

export function MinusButton(props: MinusButtonProps) {
  const { onClick, className } = props;
  return (
    <IconButton
      ariaLabel="Minus"
      className={`${styles.icon} ${className}`}
      size="small"
      style="default"
      prominence="secondary"
      onClick={onClick}
      icon={<Minus />}
    ></IconButton>
  );
}
